export class Section {
  title: string;
  route: string;
  carrierName: string;
  handshakeGUID: string;


  constructor(Title: string, Route: string, handshakeGUID?: string, CarrierName?: string) {
    this.title = Title;
    this.route = Route;
    this.carrierName = CarrierName;
    this.handshakeGUID = handshakeGUID;
  }
}
